import { render, staticRenderFns } from "./ArticleDesktop.vue?vue&type=template&id=2ab4c28a"
import script from "./ArticleDesktop.vue?vue&type=script&lang=js"
export * from "./ArticleDesktop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports